'use strict'

import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'

import { BaseView } from '../../../shared/utils/baseComponent'
import template from './reports.template.pug'

class CustomerReportsController extends BaseView {
  constructor($mdSidenav, $filter, $mdToast, $mdMedia, $mdMenu, $element, $mdDialog, $state, $locale, $scope) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $mdSidenav, $filter, $mdToast, $mdMedia, $mdMenu, $mdDialog, $state, $locale, $scope },
      {
        eyeCatcher: require('../../assets/reports.svg'),
      },
    )

    this.enrichReports()
  }

  openItemMenu($mdMenu, ev) {
    $mdMenu.open(ev)
  }

  handleSuccess(msg) {
    const toast = this.$mdToast.simple().textContent(msg).action('OK').position('bottom').hideDelay(10000)
    this.$mdToast.show(toast)
  }

  handleError(msg) {
    const toast = this.$mdToast.simple().textContent(msg).position('bottom').hideDelay(10000)
    this.$mdToast.show(toast)
  }

  reload() {
    this.customer.getReports().then((reports) => {
      this.reports = reports
      this.enrichReports()
    })
  }

  deleted() {
    this.reload()
    this.handleSuccess('Report erfolgreich gelöscht')
  }

  enrichReports() {
    this.reports = _sortBy(this.reports, (r) => moment(r.createdAt))
    this.reports.forEach((report) => {
      let user = _find(this.users, { user: { email: report.creatorMail } })
      report.creator = user && user.user ? user.user.firstname + ' ' + user.user.lastname : report.creatorMail
    })
  }

  openCreateReportDialog() {
    const createDialog = this.$mdDialog.createReportDialog({
      locals: {
        customer: this.customer,
      },
      resolve: {
        reportTypes: () => {
          return this.customer.getReportTypes()
        },
      },
    })

    return this.$mdDialog.show(createDialog).finally(() => {
      this.reload()
    })
  }
}

export const customerReportsComponent = {
  controller: CustomerReportsController,
  bindings: {
    customer: '<',
    reports: '<',
    users: '<',
  },
  template: template(),
}



// WEBPACK FOOTER //
// ./app/reports/containers/reports/reports.component.js